import { useIntl } from 'react-intl';
import { SearchIllustration } from '@tlx/atlas';
import { getContextId } from '@tlx/astro-shared';
import { TableEmptyState } from '@Component/Table/Table.utils.tsx';

export function TableEmptyCreatePension() {
    const intl = useIntl();

    return (
        <TableEmptyState
            titleMessage={intl.formatMessage({
                id: 'tsk_filter_no_pension_payments',
            })}
            descriptionMessage={intl.formatMessage({
                id: 'tsk_filter_results_try_create_pension_payment',
            })}
            buttonContent={intl.formatMessage({
                id: 'text_register_otp',
            })}
            illustration={<SearchIllustration size={'small'} />}
            onClickAction={() => {
                window.open(`/execute/reimbursementMenu?contextId=${getContextId()}#obligatoryPension`);
            }}
        />
    );
}
